import { axiosClient } from "@/shared/api/axios-client";

/** Una entrada del catálogo de permisos (RBAC · P46). */
export interface PermisoGestion {
  id: string;
  codigo: string;
  grupo: string;
  descripcion: string;
  /** Definido en código · no se elimina ni cambia su código (solo desactivar). */
  esDeSistema: boolean;
  /** Personalizado y aún sin cablear en el código → no otorga acceso todavía. */
  pendienteCablear: boolean;
  activo: boolean;
  /** Cuántos roles lo tienen asignado. */
  rolesCount: number;
}

export interface CrearPermisoInput {
  codigo: string;
  grupo: string;
  descripcion: string;
}

export interface EditarPermisoInput {
  grupo: string;
  descripcion: string;
}

export async function listarCatalogoPermisos(): Promise<PermisoGestion[]> {
  const { data } = await axiosClient.get<PermisoGestion[]>("/api/admin/permisos/gestion");
  return data;
}

export async function crearPermiso(input: CrearPermisoInput): Promise<PermisoGestion> {
  const { data } = await axiosClient.post<PermisoGestion>("/api/admin/permisos", input);
  return data;
}

export async function editarPermiso(id: string, input: EditarPermisoInput): Promise<PermisoGestion> {
  const { data } = await axiosClient.put<PermisoGestion>(`/api/admin/permisos/${id}`, input);
  return data;
}

export async function cambiarEstadoPermiso(id: string, activo: boolean): Promise<PermisoGestion> {
  const { data } = await axiosClient.post<PermisoGestion>(`/api/admin/permisos/${id}/estado`, { activo });
  return data;
}

export async function eliminarPermiso(id: string): Promise<void> {
  await axiosClient.delete(`/api/admin/permisos/${id}`);
}
